import PostalEnvelope from './raf-postal-envelope.webp';
import CheckBackSoon from './check-back-soon.webp';

export default { PostalEnvelope, CheckBackSoon };
